var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07161 17.3327C4.46911 17.3327 0.738281 13.6018 0.738281 8.99935C0.738281 4.39685 4.46911 0.666016 9.07161 0.666016C13.6741 0.666016 17.4049 4.39685 17.4049 8.99935C17.4049 13.6018 13.6741 17.3327 9.07161 17.3327ZM8.23828 11.4993V13.166H9.90495V11.4993H8.23828ZM9.90495 10.1285C10.5747 9.92666 11.1496 9.49098 11.5251 8.9008C11.9005 8.31063 12.0515 7.60523 11.9506 6.91307C11.8496 6.22091 11.5034 5.58805 10.975 5.12973C10.4465 4.67141 9.77109 4.41813 9.07161 4.41602C8.39733 4.41596 7.74383 4.64948 7.22227 5.07684C6.70072 5.50421 6.34329 6.09904 6.21078 6.76018L7.84578 7.08768C7.89218 6.85554 8.00355 6.64135 8.16692 6.47003C8.33029 6.29871 8.53896 6.1773 8.76863 6.11994C8.99831 6.06257 9.23956 6.07161 9.4643 6.14599C9.68904 6.22037 9.88804 6.35705 10.0381 6.54011C10.1882 6.72317 10.2833 6.94509 10.3122 7.18005C10.3411 7.41501 10.3027 7.65335 10.2014 7.86733C10.1002 8.08132 9.94023 8.26215 9.74022 8.38879C9.54021 8.51543 9.30835 8.58267 9.07161 8.58268C8.8506 8.58268 8.63864 8.67048 8.48236 8.82676C8.32608 8.98304 8.23828 9.195 8.23828 9.41602V10.666H9.90495V10.1285Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.54312afa136eee5d1cef53f8622a2147.svg";
export { ForwardRef as ReactComponent };